import {RoomClientState} from '../RoomClientState.ts'
import {UIRoomCenterSettingSpeedType} from './UIRoomCenterSettingsSpeedController'
import {UIPopupController} from '../ui_popup/UIPopupController.ts'
import {CA} from '../analytics/Analytics.ts'
import {EnumUtils} from '../../../../shared/utils/EnumUtils.ts'
import {StorageWrapper} from '../StorageWrapper.ts'
import {clientI18n} from '../ClientI18n.ts'
import {TranslationObject} from '@colonist/i18n'
import {BotSpeedSettings, GameSpeedSettings, RoomSettingConstants} from '@colonist/game-base-types'
import RoomGameSpeeds from '@static/images/room_game_speeds.png'
import {socket} from '../EntryShared.ts'
import {setElementOnClick} from '../ui_utils/DomUtils'

export class UIRoomCenterSettingsSpeedView {
    container: HTMLDivElement
    speedInput: HTMLHeadingElement
    speedOptions: (keyof typeof GameSpeedSettings)[]
    speedRightArrow: HTMLImageElement
    speedLeftArrow: HTMLImageElement
    speedDivBody: HTMLDivElement
    speedInfo: HTMLImageElement
    speedSettings: typeof GameSpeedSettings | typeof BotSpeedSettings
    speedDefaultSetting: keyof typeof GameSpeedSettings
    speedSocketCommand: (value: string) => void

    constructor(container: HTMLDivElement, type: UIRoomCenterSettingSpeedType) {
        this.container = container
        switch(type) {
            case UIRoomCenterSettingSpeedType.GameSpeed: this.initGameSpeedSettings(); break
            case UIRoomCenterSettingSpeedType.BotSpeed: this.initBotSpeedSettings(); break
        }
        this.speedOptions = []
        UIRoomCenterSettingsSpeedView.setSpeedOptions(this.speedSettings, this.speedOptions)
    }

    initGameSpeedSettings() {
        this.speedInput = this.container.querySelector('#room_center_gamespeed_settings_input') as HTMLHeadingElement
        this.speedRightArrow = this.container.querySelector('#gamespeed_settings_right_arrow') as HTMLImageElement
        this.speedLeftArrow = this.container.querySelector('#gamespeed_settings_left_arrow') as HTMLImageElement
        this.speedDivBody = this.container.querySelector('#gamespeed_settings_body') as HTMLDivElement
        this.speedInfo = this.container.querySelector('#gamespeed_settings_speed_info') as HTMLImageElement
        this.speedSettings = GameSpeedSettings
        this.speedDefaultSetting = EnumUtils.getEnumKey(RoomSettingConstants.DEFAULT_GAME_SPEED_SETTING, GameSpeedSettings)
        const speedSocketCommand = (value: string) => {
            StorageWrapper.setRoomGameSpeedSetting(this.speedSettings[value])
            socket.roomClient.setGameSpeed(GameSpeedSettings[value])
        }
        this.speedSocketCommand = speedSocketCommand

        setElementOnClick(this.speedInfo, () => UIRoomCenterSettingsSpeedView.clickedSpeedInfo())
    }

    private static clickedSpeedInfo() {
        CA.sendGoogleAnalyticsEvent(CA.Category.Room, CA.Label.ClickedRoomGameSpeedInfo)
        const imageAlt = clientI18n.t('strings:roomPage.gameSpeeds')
        const gameSpeedChartImage = `<div class='room-map-preview-grid'><center><img src='${RoomGameSpeeds}' alt='${imageAlt}' style='width: 70%'></center>`
        const bodyImage: TranslationObject = {
            key: 'strings:colonistCommon.utils.#buffer',
            options: {
                value: gameSpeedChartImage,
                interpolation: {
                    escapeValue: false,
                },
            },
        }
        UIPopupController.createSimplePopup({key: 'strings:roomPage.gameSpeeds'}, bodyImage)
    }

    initBotSpeedSettings() {
        this.speedInput = this.container.querySelector('#room_center_botspeed_settings_input') as HTMLHeadingElement
        this.speedRightArrow = this.container.querySelector('#botspeed_settings_right_arrow') as HTMLImageElement
        this.speedLeftArrow = this.container.querySelector('#botspeed_settings_left_arrow') as HTMLImageElement
        this.speedDivBody = this.container.querySelector('#botspeed_settings_body') as HTMLDivElement
        this.speedSettings = BotSpeedSettings
        this.speedDefaultSetting = EnumUtils.getEnumKey(RoomSettingConstants.DEFAULT_BOT_SPEED_SETTING, BotSpeedSettings)
        const speedSocketCommand = (value: string) => {
            StorageWrapper.setRoomBotSpeedSetting(this.speedSettings[value])
            socket.roomClient.setBotSpeed(BotSpeedSettings[value])
        }
        this.speedSocketCommand = speedSocketCommand
    }

    getSetting(newRoomState: RoomClientState, type: UIRoomCenterSettingSpeedType): keyof typeof GameSpeedSettings {
        switch(type) {
            case UIRoomCenterSettingSpeedType.GameSpeed: return EnumUtils.getEnumKey(newRoomState.gameSetting.gameSpeed, this.speedSettings)
            case UIRoomCenterSettingSpeedType.BotSpeed: return EnumUtils.getEnumKey(newRoomState.gameSetting.botSpeed, this.speedSettings)
        }
    }

    private static setSpeedOptions(enumName: any, optionsArray: string[]) {
        EnumUtils.loopEnums(enumName, (innerElement, elementNo) => {
            optionsArray.push(enumName[innerElement].toString())
        })
    }
}
